import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getTimelineCount = createAsyncThunk(
  "leadTimeline/getTimelineCount",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/leads/timelineCounts/${data?.leadId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
